import { render, staticRenderFns } from "./companyClient.vue?vue&type=template&id=6b9266c4&scoped=true"
import script from "./companyClient.vue?vue&type=script&lang=js"
export * from "./companyClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9266c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9266c4')) {
      api.createRecord('6b9266c4', component.options)
    } else {
      api.reload('6b9266c4', component.options)
    }
    module.hot.accept("./companyClient.vue?vue&type=template&id=6b9266c4&scoped=true", function () {
      api.rerender('6b9266c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/companyClient.vue"
export default component.exports